import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  INVITE_TO_APPLY: '2294',
  ADD_LEASE: '2295',
  SET_UP_PAYMENTS: '2296',
  CREATE_LISTING: '2297',
} as const;

export type SelectAvailableActionsTriggerObject = 'posting_path' | 'zrm_user_onboarding';

export type SelectAvailableActionsEventProps = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
  triggerObject?: SelectAvailableActionsTriggerObject;
};

// https://dataportal.zillowgroup.net/event-registry/2294
export const emitInviteToApplyEvent = ({
  currentProperty,
  user,
  triggerObject = 'posting_path',
}: SelectAvailableActionsEventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.INVITE_TO_APPLY,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'invite_to_apply',
    },
    semantic: {
      semantic_event_nm: 'set_up_applications',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2295
export const emitAddLeaseEvent = ({
  currentProperty,
  user,
  triggerObject = 'posting_path',
}: SelectAvailableActionsEventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '',
      event_type_id: EVENT_IDS.ADD_LEASE,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'add_a_lease',
    },
    semantic: {
      semantic_event_nm: 'set_up_leases',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2296
export const emitSetUpPaymentsEvent = ({
  currentProperty,
  user,
  triggerObject = 'posting_path',
}: SelectAvailableActionsEventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SET_UP_PAYMENTS,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'set_up_payments',
    },
    semantic: {
      semantic_event_nm: 'set_up_payments',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2297
export const emitCreateListingActionEvent = ({
  currentProperty,
  user,
  triggerObject = 'posting_path',
}: SelectAvailableActionsEventProps) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CREATE_LISTING,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties',
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: 'intent_selection_list',
    },
    semantic: {
      semantic_event_nm: 'manage_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
